<template>
  <div class="periods">
    <div class="action">
      <button class="btn btn-dark add" v-on:click="add">Dodaj</button>
    </div>

    <div class="list">
      <ul class="list-unstyled">
        <li v-for="item in sorted(wallets, 'year')" :key="item.year">
          <div class="year">{{ item.year }}</div>
          <ul class="list-unstyled months">
            <li
              v-for="wallet in sorted(item.wallets, 'month')"
              :key="wallet.year + '-' + wallet.month"
              v-bind:class="{ new: !wallet.id }"
            >
              <router-link
                :to="{
                  name: 'wallet',
                  params: { year: wallet.year, month: wallet.month },
                }"
                >{{ wallet.month | month }}</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <PeriodEdit ref="period"></PeriodEdit>
  </div>
</template>

<script>
export default {
  methods: {
    add() {
      let period = this.$piggyBank.data.newPeriod();

      this.$refs.period
        .show(period)
        .then((result) => {
          let data = this.$piggyBank.data.newWalletData(
            result.year,
            result.month
          );
          this.$piggyBank.data.addWallet(result.year, result.month, data);
          this.backdoor = this.$piggyBank.data.wallets;
        })
        .catch(() => {});
    },
    sorted(value, field) {
      return [...value].sort((a, b) => {
        if (field) {
          return a[field] < b[field] ? 1 : -1;
        } else {
          return a < b ? 1 : -1;
        }
      });
    },
  },
  data() {
    return {
      backdoor: [],
    };
  },
  mounted() {
    this.backdoor = this.$piggyBank.data.wallets;

    this.$root.$on("logged", () => {
      this.backdoor = this.$piggyBank.data.wallets;
      this.$forceUpdate();
    });

    this.$root.$on("logged-out", () => {
      this.backdoor = this.$piggyBank.data.wallets;
      this.$forceUpdate();
    });
  },
  computed: {
    wallets() {
      let wallets = this.backdoor; //this.$piggyBank.data.wallets;
      let groups = this.$tools
        .groupBy(wallets, "year", this.$tools.map.groupBy)
        .map((item) => {
          return {
            year: item.group,
            wallets: item.items,
          };
        });
      return groups;
    },
  },
};
</script>

<style lang="scss">
.periods {
  height: 100%;
  margin: 0px;
  display: flex;
  flex-direction: column;

  .action {
    padding: 3px;

    .add {
      width: 100%;
    }
  }

  .list {
    flex: 1;
    overflow: hidden;

    ul.list-unstyled {
      height: 100%;
      overflow-y: auto;
    }
  }
}

ul:not(.months) {
  // overflow-y: auto;
  li {
    position: relative;

    & > .year {
      position: absolute;
      // top: 0;
      left: 0;
      bottom: 0;
      // width: 100%;
      // top: 50%;
      font-size: 10px;
      color: gray;
      // transform: rotate(-90deg);
      // border: 1px solid red;
    }

    ul.months {
      // width: 80px;
      padding-left: 30px;
      border-bottom: 1px solid gray;

      .new {
        background: red;
      }

      li {
        text-align: center;
        padding: 0px 10px;
      }
    }
  }

  // & > li:not(:first-child) {
  //   border-top: 1px solid gray;
  // }
}
</style>